import { useProgram, usePrograms } from "./hooks";

const Program = {
  useOne: useProgram,
  useAll: usePrograms,
};
export default Program;
